import { commonEnvVariables } from "@/commonEnvVariables";
const envVariables = commonEnvVariables();

export const speakerRegistrationConstants = {
    YPO_ORG: 'https://www.ypo.org/',
    REQUIRED_FIELD: 'Cannot be left blank',
    PREFERRED_NAME: 'Preferred Name',
    FAMILY_NAME: 'Last (Family) Name',
    FIRST_NAME: 'First (Given) Name',
    TITLE: 'Title (e.g. CEO or Motivational Speaker)',
    YPO_ASSOCIATION: 'How are you associated with YPO',
    TRAVEL_FROM_CITY: 'Travels From City',
    COUNTRY: 'Country',
    PHONE_NUMBER: 'Primary Phone Number',
    PHONE_NUMBER_PLACEHOLDER: 'Phone Number',
    PRIMARY_EMAIL: 'Primary Email',
    COUNTRY_CODE: ' Country Code',
    PHONE_NUMBER_PREFIX: '+',
    REQUIRED: 'Required',
    YOUR_BIOGRAPHY: 'Your Biography',
    LANGUAGE_PRESENT_IN: 'Languages you Present In',
    PREVIOUS_YPO_SPEAKER: 'Have you previously spoken at a YPO event?',
    PREVIOUS_SPEAKER_EVENTS: 'If yes, List all YPO events you have spoken at',
    OTHER_ENGAGEMENTS_LINKS: 'Links to other engagements, e.g., TED Talk',
    REFERRALS: 'List YPO member or management associate referrals',
    LINKED_IN_URL: 'Your LinkedIn URL',
    GENDER: 'Gender',
    PHOTO: 'Your Photo',
    YPO_SPEAKER: 'Become a YPO Speaker',
    BECOME_A_CFF: 'Become a CFF',
    WEBSITE_URL: 'Your Website URL',
    TOPICS: 'Select topics from categories below',
    ADVENTURES_EXPERIENCES: 'Adventures and Experiences',
    BUSINESS_GROWTH: 'Business Growth',
    BUSINESS_INNOVATOR: ' Business Innovation',
    BUSINESS_LEADERSHIP: 'Business Leadership',
    FAMILY_FOCUS: 'Family Focus',
    GENERATIONAL_SUCCESS: 'Generational Success',
    PERSONAL_DEVELOPMENT: 'Personal Development',
    PRESENTATION_STYLE: 'Show Your Presentation Style',
    VIDEO_REQUIREMENTS: 'Video Requirements',
    MORE_INFORMATION: 'MORE INFORMATION',
    FEES_RANGE: 'Fee Range for In-Person Event <small>(exclude travel expenses)</small>*',
    REDUCED_FEES: 'Are you available for a reduced fee if speaking at 3 or more engagements?',
    RESOURCE_SERVING: "Are you interested in speaking at YPO's virtual events?",
    TERMS_AND_CONDITIONS: 'I have read and agree with ',
    YPO_NON_SOLICITATION_POLICY: "YPO's Non-Solicitation Policy",
    RESOURCE_DiRECTORY_TERMS_OF_USE: 'Resource Directory Terms of Use',
    YPO_NON_SOLICITATION_POLICY_PDF:
    `${envVariables.BLOB_CDN_END_POINT}/publiclyaccessiblefiles/YPO_Non_Solicitation_Policy.pdf`,
    INTEREST_P:
        'Thank you for your interest in speaking to YPO members. Your form has been successfully submitted and our team is now in the process of reviewing your information. We will follow up with you via email within five business days to let you know if we need anything further, and will also advise you for next steps',
    NEXT: 'Next',
    BACK: 'Back',
    GO_TO_HOME: 'RETURN TO HOME',
    MEMBER_MESSAGE: 'To save your time, we have filled in this portion with information from your YPO profile',
    CONTINUE: 'CONTINUE',
    FALL_BACK_IMAGE_URL:
        'https://ypodfilestoragedev.blob.core.windows.net/profileimageplaceholders/avatar-placeholder-male.jpg',
    NEGOTIATE: 'Are you willing to negotiate to meet YPO budget Constraints?',
    TRP: 'Are you interested in participating in a Travelling Resource Program (TRP)?',
    ALL_CATEGORIES: 'All this category',
    WHAT_IS_TRP: 'What is a Traveling Resource Program (TRP)?',
    WHAT_IS_TRP_TEXT:
        'TRPs have been designed to share costs and leverage speaker opportunities among three or more chapters that engage with the same speaker over consecutive event dates. Participating chapters pay a reduced fee of at least 25 percent for speaker.',
    OK: 'OK',
    SUBMIT: 'Submit',
    YPO_MEMBER: 'Are you a member of YPO? If so, please use the',
    YPO_MEMBER_SPEAKER: 'YPO MEMBER SPEAKER FORM',
    YPO_NON_SOLICITATION_TITLE: 'Non-Solicitation, Promotion, and Sales',
    YPO_NON_SOLICITATION_TEXT: `<p>YPO has a strict non-solicitation culture within our community. Speakers should not solicit speaking opportunities during their presentation or directly with YPO members, even if they are in your network. All event champions have access to the central Resource Directory and can search for speakers based on several criteria including their topic of interest.</p>`,
    WHAT_TO_DO: 'What to do',
    VIDEO_LENGTH: 'Video should be <strong> 3-5 minutes </strong> in length',
    NOTE: 'Note',
    NOTE_TEXT: 'This information will not be saved if you refresh or close the browser.',
    DRAG_PHOTO: 'Drag a photo or upload',
    UPLOAD_PHOTO: 'a photo from your device',
    UPLOAD_ANOTHER_VIDEO: 'Record and Upload Another Video',
    FILE_TYPE_SIZE: 'File must be JPG, GIF, or PNG; < 2MB not to exceed 500 x 500 pixels',
    IMAGETYPES_SUPPORTED: ['.jpg', '.png', '.jpeg', '.bmp'],
    VIDEO_TYPES_SUPPORTED: ['.mp4', '.mov'],
    VIDEO_TYPES_SUPPORTED_MESSAGE: 'File must be MP4 or MOV',
    UPLOAD_A_VIDEO_PRESENTATION: 'Upload a Video',
    VIDEO_MUST_NOT_EXCEED: 'Video size must not exceed 500MB',
    VIDEO_INFO:
        'YPO is the premier chief executive leadership organization in the world, with members who expect actionable content from speakers. Record and upload a short video on your smartphone to be published in the YPO Resource Directory, briefly describing:',
    VIDEO_INFO_POINT1: 'How your style differs from other thought leaders',
    VIDEO_INFO_POINT2: 'How you will tailor content that engages YPO members',
    VIDEO_INFO_POINT3:
        'How your presentation delivery and content will  be interactive and customized for premier business leaders',
    VIDEO_INFO_POINT4: 'The take-home value and impact you will have',
    QUESTIONS: 'Questions? Email',
    EMAIL_ID: 'regionallearningspecialists@ypo.org',
    CLEAR_ALL_THIS_CATEGORY: 'Clear all This Category',
    YPO_CHAPTER: 'Must Provide: YPO Chapter Name and Date',
    COUNTRY_CODE_MAX_LENGTH: 3,
    PHONE_NUMBER_MAX_LENGTH: 20,
    SAVE: 'Save',
    CANCEL: 'Cancel',
    EDIT: 'Edit',
    EDIT_SPEAKER_PROFILE_INFORMATION: 'EDIT Your Speaker Profile INFORMATION',
    EDIT_PROFILE_PHOTO: 'Edit Profile Photo',
};
export const currentViewingPages = {
    about: 'about',
    presentation: 'presentation',
    biography: 'biography',
    feeRange: 'feeRange',
};
export const speakerValidationConstants = {
    REQUIRED_TEXT_FIELD: 'Cannot be left blank',
    ASSOCIATION: 'Select at least one association',
    VALID_CITY: 'Not a valid city',
    VALID_COUNTRY: 'Not a valid country',
    VALID_NUMBER: 'Invalid Phone number',
    VALID_EMAIL: 'This is not a valid email address',
    LANGUAGE_SELECTION: 'Select at least one language',
    TOPIC_SELCTION: 'Select at least one Topic',
    FEES_RANGE_SELECTION: 'Select your Fees Range',
    SELECTION_VALIDATION: 'You must select one option',
    SELECT_REGION: 'Select Region',
    SELECT_RATING: 'Invalid Rating',
    INVALID_YEAR: 'Invalid Year',
    QUALIFICATION_EMPTY_ERROR: 'Qualifications should not be empty',
    RETREAT_TOPIC_ERROR: 'Retreat topic should not be empty',
    SINGLE_IMAGE: 'Select only one image',
    FILE_DOES_NOT_MEET_REQUIREMENT: 'File does not meet requirements',
    SELECT_AT_LEAST_ONE_TOPIC: 'Select at least one topic',
    PLEASE_FILL_ALL_THE_MANDATORY_FIELDS: 'Please fill in the required fields',
    VIDEO_SIZE: 'Video size is more than 500MB',
    YPO_POLICY_ERROR: `You must confirm you have read Resource Directory Terms of Use`,
    VALID_URL: 'Please enter a valid url',
    PREVIOUS_EVENT_ERROR: 'You must list at least one event',
    VALID_SELECTION_ERROR: 'Select YES or NO',
    UPLOAD: 'Upload',
    NEW_VIDEO_UPLOAD_CONFIRMATION:
        'Do you want to upload a New Video? Which will eventually delete the existing video.',
     NEW_NOTE: 'Inclusion in the YPO Resource Directory is at the sole discretion of YPO.',   
};

export const stepperHeadersConstants = {
    STEP1_HEADING: 'About You',
    STEP2_HEADING: 'Presentation',
    STEP3_HEADING: 'Biography',
    STEP4_HEADING: 'Fees',
    STEP1: 'Step 1 of 4',
    STEP2: 'Step 2 of 4',
    STEP3: 'Step 3 of 4',
    STEP4: 'Step 4 of 4',
    THANKYOU: 'Thank You',
};

export const SpeakerApplicants = {
    SEARCH_FILTERS: 'SEARCH_FILTERS',
    ZERO_SEARCH_RESULTS: 'Showing 0 results',
    NO_FILTER_RESULTS: `Sorry! We haven't got any exact matches for your search at the moment`,
    NO_SEARCH_RESULTS_MESSAGE:
        'Please check your spelling and try again, or if you are refining an existing search, please try removing some of the filters you applied. You can also click on ‘Reset’ button to view the full Directory again',
    VIEW_FULL_Speaker_Directory: 'view the full Speaker Directory',
    VIEW_FULL_CFF_Directory: 'view the full CFF Directory',
    DETAILS_SAVED_SUCCESSFULLY: 'Profile saved successfully',
    SUCCESS_DURATION: '2500',
    searchResultOffsetStep: 50,
    REVIEWED_APPLICANTS: 'Reviewed Applicants',
    APPROVED: 'APPROVED',
    DENIED: 'DENIED',
    SHOWING: 'Showing',
    PENDING_REQUESTS: 'Pending Requests',
    PENDING_APPLICANTS: 'Pending Applicants',
    STATUS_ITEMS: ['Approved Only', 'Denied Only', 'Approved and Denied'],
    PENDING_STATUS_ITEMS: ['Approve', 'Deny'],
    SEARCH_VIEW_SPEAKER_DIRECTORY: 'Search/View Speaker Directory',
    SPEAKER_ADMINISTRATION: 'Speaker Administration',
    PENDING: 'pending',
    REVIEWED: 'reviewed',
    RESOURCE_DIRECTORY: 'Resource Directory',
    YPO_SPEAKERS: 'YPO Speakers',
    SEARCH: 'SEARCH',
    FIND_A_SPEAKER_BY_NAME: 'FIND A SPEAKER BY NAME',
    REFINE_LIST: 'Refine List',
    USE_BELOW_TOOLS_NARROW_RESULTS: 'Use the below tools to narrow your results.',
    SHOW_SPEAKERS_WHO_ARE: 'Show Speakers Who Are:',
    SELECT_FEE_RANGE: 'Select Speaker Fee Range (USD)',
    TRAVELS_FROM_COUNTRY: 'Travels From Country',
    REGION: 'YPO Region',

    TRAVELS_FROM_CITY: 'Travels From City',
    COUNTRY: 'Country',
    CATEGORIES: 'Categories:',
    SELECT_TOPIC_TOPICS: 'Select a topic or topics',
    RESET: 'RESET',
    SORT_OPTIONS: ['First/Preferred Name A-Z', 'Last Name A-Z'],
    SORT_KEY_TO_LANGUAGE_CONVERTER: {
        LastName: 'Last Name A-Z',
        Name: 'First/Preferred Name A-Z',
    },
    SORT_LANGUAGE_TO_KEY_CONVERTER: {
        'Last Name A-Z': 'LastName',
        'First/Preferred Name A-Z': 'Name',
    },
    FEE_RANGE_VALUES: ['0', '1000', '3000', '5000', '10000', '20000', '50000', '100000', '100000+'],
    FEE_RANGE_TO_KEY_CONVERTER: {
        '0': '0',
        '1000': '1',
        '3000': '2',
        '5000': '3',
        '10000': '4',
        '20000': '5',
        '50000': '6',
        '100000': '7',
        '100000+': '8',
    },
    FIND_A_SPEAKER: 'Find a Speaker',
    BECOME_A_SPEAKER: 'Become a Speaker',
    VIEW_SPEAKER_PROFILE_PENDING: 'View/Edit My Speaker Profile (Pending Approval)',
    VIEW_SPEAKER_PROFILE: 'View/Edit My Speaker Profile',
    APPROVE_DENY: 'Approve or Deny',
    ARE_YOU_SURE_WANT_TO_APPROVE_THE_APPLICANT: 'Are you sure want to approve the Applicant?',
    ARE_YOU_SURE_WANT_TO_DENY_THE_APPLICANT: 'Are you sure want to deny the Applicant?',
    MEMBER: 'Member',
    MORE_INFORMATION: 'More Information',
    YPO_EVENTS_INFO:
        '<p> If a speaker has indicated a past YPO event history, any champions considering the speaker for events should connect with the speaker directly to find out more information.</p> <p>The <a target="_blank" href="https://connect.ypowpo.org/portal/~/media/7002187A1039463DA58E19A289BA2188.ashx">Engage and Inspire </a> and <a target="_blank" href="https://connect.ypowpo.org/portal/~/media/C19B1A2AA55B459F878012CE7C40A6C1.ashx">Find the Right Fit</a> speaker guides are helpful tools in preparing for these exploratory discussions.</p> <p></p>Then the next step is to reach out to the chapters or champions the speaker provides as a reference, to gather event ratings and participants comments.</p>',
    YOU_TUBE_EMBED_LINK: 'https://www.youtube.com/embed/',
    YOU_TUBE: 'youtube',
    RESOURCE_DIRECTORY_LINK: 'ResourceDirectory',
    OTHER_PRESENTATIONS: 'Other Presentations',
    BACK_TO_SPEAKER_DIRECTORY: 'Back to Speaker Directory',
    // MEMBER: 'MEMBER',
    VIEW_MY_YPO_PROFILE: 'View my YPO Profile',
    FEE_RANGE: 'Fee Range',
    WILLING_TO_NEGOTIATE_FEES: 'Willing to Negotiate Fees',
    // TRAVELS_FROM: 'Travels from',
    SPOKEN_AT_YPO_EVENTS: 'Spoken at YPO Events',
    MY_CONTACT_INFORMATION: 'My Contact Information',
    TOPICS: 'Topics',
    LEADERSHIP_DEVELOPMENT: 'Leadership Development',
    PERSONAL_DEVELOPMENT: 'Personal Development',
    STRATEGY: 'Strategy',
    ABOUT_ME: 'About Me',
    SPEAKER_PARTICIPATES: 'Speaker Participates',
    PRESENTATIONS: 'Presentations',
    LANGUAGES_SPOKEN: 'Languages Spoken',
    REFERRALS: 'Referrals',
    TRAVEL_RESOURCE_PROGRAM: 'Travel Resource Program',
    SPEAKER_IS_AVAILABLE_TO_SPEAK_ONLINE_OR_VIRTUAL: 'Speaker is Available to Speak Online or Virtual',
    YES: 'Yes',
    NO: 'No',
    Section_A: 'EDIT YOUR YPO MEMBER Profile Information',
    NOTE: 'Any changes made to this section will also reflect in your YPO Member Profile immediately',
    UNLOCK_TO_EDIT_MEMBER_PROFILE: 'UNLOCK TO EDIT YOUR YPO MEMBER PROFILE',
    EDIT_SPEAKER_PROFILE_BELOW: 'EDIT SPEAKER PROFILE BELOW',
    SAVE_POPUP_DIALOG:
        'Please wait while we are submitting your information. This sometime takes up to 3 to 5 minutes depending on your internet speed. This information will not be saved if you refresh or close the browser.',
    SAVE_CONFIRMATION_WITHOUT_VIDEO_MESSAGE: `Congratulations your speaker form was successfully submitted. However, due to internet connectivity issues your video didn’t upload. Please email your video link to <a style="color: white" href="mailto:regionallearningspecialists@ypo.org">regionallearningspecialists@ypo.org</a>.`,
    SAVE_FAILURE_MESSAGE: 'Unable to connect to the serve',
    PLEASE_WAIT: 'Please wait...',
    WE_APOLOGIES: 'We apologies for making you wait...',
    SPEAKER_TYPE: 'speakerType',
    SPEAKER_STATUS: 'speakerStatus',
    PREVIOUS_PAGE: 'PreviousPage',
    EDIT_PROFILE: 'Edit Profile',
    MEMBERS: 'Member and Spouse/Partner',
    AVAILABLE_ONLINE: 'Available Online or Virtually',
    TRP_PROGRAM: 'Interested in the TRP',
    YPO_REFERRED: 'Referred by YPO Members',
    PREVIOUS_SPEAKER_AT_YPO: 'Spoken at Previous YPO Events',
    FEE_NEGOTIATION: 'Willing to Negotiate Fee',
    YPO_FACILITATORS: 'YPO Forum Facilitators',    
    FIND_A_CFF_BY_NAME: 'FIND A CFF BY NAME',
    IS_CFF_SPEAKER: 'IsCFFSpeaker',
    SPEAKER: 'Speaker',
    SEARCH_FOR_SPEAKER: 'Search for a Speaker',
    FIND_A_CFF: 'CFF Resource Directory',
    YPO_GUIDES: `See the YPO guides <a href="https://connect.ypowpo.org/portal/~/media/C19B1A2AA55B459F878012CE7C40A6C1.ashx" target="_blank">Find the Right Fit</a> and <a href="https://connect.ypowpo.org/portal/~/media/7002187A1039463DA58E19A289BA2188.ashx" target="_blank">Engage and Inspire </a>`,
    TOOLTIP_FOR_FIND_SPEAKER_BY_NAME: `The speakers featured in the YPO Resource Directory are neither endorsed nor vetted by the management organization. We encourage champions to vet speakers before booking by conducting an exploratory call. See the YPO guides 'Find the Right Fit' and 'Engage and Inspire'.`,
    TOOLTIP_FOR_CFF:
        'YPO Certified Forum Facilitators (CFFs) deliver core forum programs, design and facilitate member, spouse and partner retreats, are consultants to individuals and groups, and are resources for YPO programs and events. YPO CFFs participate in a rigorous application and certification process led by the YPO Forum Committee, that ensures YPO members and forums have access to the most qualified facilitators, trainers and coaches. Unique to YPO, CFFs are experienced in working with executives, and possess an expansive understanding of YPO’s culture and member expectations, and the global business landscape.',
    NO_RESULT_FOUND: 'No results found',
    INTERESTED_IN_THE_TRP:
        'TRPs have been designed to share  costs and leverage speaker opportunities among three or more chapters that engage with the same speaker over consecutive event dates. Participating chapters pay a reduced fee of at least 25 percent for speaker.',
    SPEAKER_RESOURCE_DIRECTORY_ADMINISTRATION: 'Back To Speaker Administration',
    BACK_TO_CFF_DIRECTORY: 'Back to CFF Directory',
    RESOURCE_DIRECTORY_TERMS_OF_USE: 'Resource Directory Terms of Use',
};
export const EditSpeakerProfile = {
    LAST_NAME: 'Last Name',
    EXISTING_AFFILIATIONS: 'Select your existing affiliations with YPO, if any?',
    FEE_RANGE_EVENT: 'Fee Range for In-Person Experience <small>(exclude travel expenses)</small>*',
    LANGUAGES: 'Languages',
    PRESENTATIONS: 'Presentations',
    UPDATE: 'Update',
    RECORD_UPLOAD_ANOTHER_VIDEO: 'Record and Upload Another Video',
    YPO_REFERRAlS: 'YPO Referrals',
    CERTIFIED_FORUM_FACILITATOR: 'Certified Forum Facilitator Information',
    SINCE: 'Since',
    REGION: 'Primary Region',
    TAGLINE: 'Tag line',
    FEES: 'Fees (Daily Rate)',
    MINIMUM: 'Minimum',
    MAXIMUM: 'Maximum',
    QUALIFICATIONS: 'Qualifications',
    NUMBER_OF_FORUM_PROGRAMS: 'Number of Forum Programs (In the past year)',
    RETREAT_TOPIC: 'Retreat Topics',
};

export const SpeakerValidationRules = {
    firstNameRules: [v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD],
    familyNameRules: [v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD],
    titleRules: [v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD],
    travelFromCityRules: [v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD],
    countryRules: [v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD],
    phoneCodeRules: [v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD],
    phoneRules: [
        v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD,
        v => (v && v.length >= 3 && v.length <= 20) || speakerValidationConstants.VALID_NUMBER,
    ],
    emailRules: [
        v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD,
        v => /.+@.+\..+/.test(v) || speakerValidationConstants.VALID_EMAIL,
    ],
    genderRules: [v => v !== '' || speakerValidationConstants.SELECTION_VALIDATION],
    urlRules: [
        v =>
            !v ||
            /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9A-Z]+([-.]{1}[a-z0-9A-Z]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(v) ||
            speakerValidationConstants.VALID_URL,
    ],
    //presentation page rules
    presentationPageValidationError: false,

    //biography rules
    biographyPageValidationError: false,
    biographyRules: [v => (!!v && v.trim() !== '') || speakerValidationConstants.REQUIRED_TEXT_FIELD],
    languagesRules: [v => v.length > 0 || speakerValidationConstants.LANGUAGE_SELECTION],
    associationsRules: [v => v.length > 0 || speakerValidationConstants.ASSOCIATION],
    previuoslySpokenAtYpoEventRules: [
        v => (v !== undefined && v !== null && v !== '') || speakerValidationConstants.VALID_SELECTION_ERROR,
    ],

    feeRangeValidationError: false,
    feeRangeRules: [v => !!v || speakerValidationConstants.FEES_RANGE_SELECTION],
    reducedFeeRules: [v => !!v || speakerValidationConstants.VALID_SELECTION_ERROR],
    travellingResourceProgramRules: [v => !!v || speakerValidationConstants.VALID_SELECTION_ERROR],
    servingResourceRules: [v => !!v || speakerValidationConstants.VALID_SELECTION_ERROR],
};
const saveSearchFilters = (routerQuery) => {
    sessionStorage.setItem(SpeakerApplicants.SEARCH_FILTERS, JSON.stringify(routerQuery));
};
export const speakerSearchConstants = {
    VIEW_SPEAKER_RESOURCE_DIRECTORY: 'VIEW SPEAKER RESOURCE DIRECTORY',
    VIEW_CFF_RESOURCE_DIRECTORY: 'VIEW CFF RESOURCE DIRECTORY',
    RESULTS_PER_PAGE: 10,
};
export const openSpeakerProfilePage = (speaker, router, routerQuery) => {
    const speakerType = speaker.speakerType === 'Non-Member' ? 'speaker' : 'member';
    sessionStorage.setItem(SpeakerApplicants.SPEAKER_TYPE, speakerType);
    sessionStorage.setItem(SpeakerApplicants.SPEAKER_STATUS, 'A');
    saveSearchFilters(routerQuery);
    if (routerQuery.speakersWhoAre && routerQuery.speakersWhoAre.includes(SpeakerApplicants.IS_CFF_SPEAKER)) {
        router.push({
            path: `/speakerPage/speakerProfile`,
            query: {
                id: speaker.speakerType === 'Non-Member' ? speaker.id : speaker.personId,
                speakersWhoAre: SpeakerApplicants.IS_CFF_SPEAKER,
            },
        });
    } else {
        router.push({
            path: `/speakerPage/speakerProfile`,
            query: {
                id: speaker.speakerType === 'Non-Member' ? speaker.id : speaker.personId,
            },
        });
    }
};
